
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/country-select",
      function () {
        return require("private-next-pages/country-select.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/country-select"])
      });
    }
  